import { CognitoUser } from 'amazon-cognito-identity-js';
import { Auth } from 'aws-amplify';
import { ACCESS_TOKEN_LOCAL_STORAGE_KEY, AUTH_USER_LOCAL_STORAGE_KEY } from 'constant';
import { AxiosResponseType, LoginInputProps } from 'types';
import Api from 'api/base/axios.config';

export const getLogo = async () => {
  const response = await Api.get('tenant/logo');

  return response.data;
};

export const getData = async () => {
  const response = await Api.get('tenant');

  return response.data;
};

export const getPermissions = async () => {
  const response = await Api.get('user/permission');

  return response.data;
};

// authentication api
export const login = async ({ email, password }: LoginInputProps): Promise<AxiosResponseType> => {
  const user: AxiosResponseType = await Auth.signIn(email, password);

  return user;
};

export const logout = async (): Promise<CognitoUser> => {
  localStorage.removeItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY);
  localStorage.removeItem(AUTH_USER_LOCAL_STORAGE_KEY);
  return await Auth.signOut();
};
